import { render } from "./DialogModal.vue?vue&type=template&id=459bf26c"
import script from "./DialogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/DialogModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "459bf26c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('459bf26c', __exports__)) {
    api.reload('459bf26c', __exports__)
  }
  
  module.hot.accept("./DialogModal.vue?vue&type=template&id=459bf26c", () => {
    api.rerender('459bf26c', render)
  })

}


export default __exports__